'use client';
import { useGamesList } from '../../casino/context/GamesListProvider/GamesListProvider';

type FavouritesContentProps = {
  header: React.ReactNode;
  emptyState: React.ReactNode;
  children: React.ReactNode;
};

/**
 * FavouritesContent adds client boundary to favourites page header and empty state.
 * By design, we should not show header when empty state is shown.
 * During refactor, decided to add this boundary component, but should it hurt performace,
 * architecture of the favourites page can be discussed.
 * @param header - The header of the favourites content.
 * @param emptyState - The empty state of the favourites content.
 * @param children - The children of the favourites content.
 * @returns The FavouritesContent component.
 */
function FavouritesContent({ header, emptyState, children }: FavouritesContentProps) {
  const { gamesCounter, hasProvidersFiltersApplied, isGamesLoading } = useGamesList();
  const shouldShowEmptyFavouriteGames = !isGamesLoading && gamesCounter === 0 && hasProvidersFiltersApplied === false;

  return (
    <>
      {!shouldShowEmptyFavouriteGames ? header : null}
      {children}
      {shouldShowEmptyFavouriteGames ? emptyState : null}
    </>
  );
}

export { FavouritesContent };
